<template>
  <div>
    <el-card body-style="padding: 0" >
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">我的试客</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户名" prop="customerName">
              <el-input v-model="queryForm.customerName" placeholder="请输入用户名"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="2">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="goToSharCode">邀请试客
      </el-button>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="customerId" label="用户ID">
          <template slot-scope="scope">
            <span style="text-align: center">{{ getStrEndWithNumbers(scope.row.customerId) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="用户名" />
        <el-table-column prop="salemanName" label="业务员" />
        <el-table-column prop="addDateTime" label="添加时间" />
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getStrEndWithNumbers} from "../../lib/utils";
import {queryCustomer} from "../../api/b2cbusiness/b2c_saleman";
import MinxinScroll from "@/components/MinxinScroll";

export default {
name: "MyCustomer",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
      },
      tableHeight: 450,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    this.getData();
  },
  methods: {
    goToSharCode(){
      this.$router.push({path:'/home/mysharecode'});
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData() {
      queryCustomer(this.queryForm, this.pagination).then(res => {
        console.log(res.data)
        if (res.success) {
          this.tableData = res.data.records;
          console.log(this.tableData)
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
